module.exports = __webpack_public_path__ + "media/title_mob_3_XL.e6b9a836.mp4";